<div class="thankyou-wrapper box">
  <div *ngIf="thankYouMessage === 'part-one'">
    <p>Thank you for completing this portion of the job application. We will now consider the information you provided in order to complete our evaluation.</p>
    <div>
      <button type="button" class="btn btn-primary" mdbWavesEffect (click)="goToJobsPage()">Browse all of our open jobs</button>
    </div>
  </div>

  <div *ngIf="thankYouMessage === 'interview'">
    Thank you. Your information has been successfully sent.
  </div>

  <div *ngIf="thankYouMessage === 'offer'">
    Thank you. Your information has been successfully sent.
  </div>

  <div *ngIf="thankYouMessage === 'message'">
    Thank you. Your message has been successfully sent.
  </div>

  <div *ngIf="thankYouMessage === 'reference-collection'">
    Thank you. Your submission has been successfully sent.
  </div>

  <div *ngIf="thankYouMessage === 'finish-later'">
    <p>Thank you for your interest in our open jobs. Please check your inbox for details on how to complete your job application at a later time.</p>
    <div>
      <button type="button" class="btn btn-primary" mdbWavesEffect (click)="goToJobsPage()">Browse all of our open jobs</button>
    </div>
  </div>
  
  <div *ngIf="thankYouMessage === 'already-completed'">
    <p>This application has already been completed. If you would like to apply, please browse our open jobs.</p>
    <div>
      <button type="button" class="btn btn-primary" mdbWavesEffect (click)="goToJobsPage()">Browse all of our open jobs</button>
    </div>
  </div>
</div>
